import { NO, UIRoute, UITextView } from "uicore-ts"
import { RHFocusManager } from "./Keyboard navigation/RHFocusManager"
import { RHNativeFocusItem } from "./Keyboard navigation/RHNativeFocusItem"
import { RHColors, RHFont } from "./Utils_slop/RHDesignTokens"
import { RHTextSanitizer } from "./Utils_slop/RHTextSanitizer"


export interface RHBreadcrumbItem {
    title: string
    route?: UIRoute
}


export class RHBreadcrumbView extends UITextView {

    _items: readonly RHBreadcrumbItem[] = []

    override _focusManager = new RHFocusManager(() =>
        Array.from(this.viewHTMLElement.querySelectorAll("a"), link => new RHNativeFocusItem(link))
    )


    constructor(elementID?: string) {
        super(elementID)
        ;(this as RHBreadcrumbView).configureWithObject({
            textColor: RHColors.textSecondary,
            isSingleLine: NO,
            style: {
                fontSize: RHFont.sizeSmall,
                fontWeight: RHFont.weightMedium,
                overflowWrap: "anywhere"
            },
            controlEventTargetAccumulator: {
                PointerTap: (_sender, event: Event) => this._breadcrumbLinkWasActivated(event),
                EnterDown: (_sender, event: Event) => this._breadcrumbLinkWasActivated(event)
            }
        })
    }


    get items(): readonly RHBreadcrumbItem[] {
        return this._items
    }

    set items(items: readonly RHBreadcrumbItem[]) {
        this._items = items
        const parts = items.map((item, index) => {
            const title = RHTextSanitizer.escapedHTML(item.title)
            if (index === items.length - 1) {
                return '<span aria-current="page">' + title + "</span>"
            }
            if (!item.route) {
                return "<span>" + title + "</span>"
            }
            // Native hash links bypass UIRoute's unsaved-change approval, as in RHBarLinkButton.
            return `<a data-route="${RHTextSanitizer.escapedHTML(item.route.stringRepresentation)}" ` +
                'role="link" tabindex="0" style="color: inherit; text-decoration: underline; cursor: pointer">' +
                title + "</a>"
        })
        this.text = '<nav aria-label="Teekond">' + parts.join(' <span aria-hidden="true">/</span> ') + "</nav>"
    }


    _breadcrumbLinkWasActivated(event: Event) {
        const target = event.target
        if (!(target instanceof Element)) {
            return
        }
        const link = target.closest<HTMLAnchorElement>("a[data-route]")
        if (!link?.dataset.route) {
            return
        }
        event.preventDefault()
        void new UIRoute(link.dataset.route).apply()
    }

}
